"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
/**
 * A component that allows simple management of the location of an object around some children
 *
 * Example:
 * ```
 * <PlacementWrapper objectPlacement={'right-end'} placedObject={<Button icon={'iconComment'} onClick={onClick} />}>
 *   <Box>Stuff and Things</Box>
 * </PlacementWrapper>
 * ```
 */
const PlacementWrapper = _ref => {
  let {
    placedObject,
    children,
    objectPlacement
  } = _ref;
  const theme = (0, _material.useTheme)();
  const outsideDirection = (0, _react.useMemo)(() => {
    if (!objectPlacement) {
      return 'column';
    }
    if (objectPlacement.startsWith('top')) {
      return 'column';
    } else if (objectPlacement.startsWith('bottom')) {
      return 'column-reverse';
    } else if (objectPlacement.startsWith('left')) {
      return 'row';
    } else {
      return 'row-reverse';
    }
  }, [objectPlacement]);
  const insideAlignment = (0, _react.useMemo)(() => {
    if (!objectPlacement) {
      return 'center';
    }
    if (objectPlacement.endsWith('start')) {
      return 'flex-start';
    } else if (objectPlacement.endsWith('end')) {
      return 'flex-end';
    } else {
      return 'center';
    }
  }, [objectPlacement]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: 'flex',
    flexDirection: outsideDirection,
    flexGrow: 1,
    marginBottom: theme.spacing(2)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    alignSelf: insideAlignment,
    margin: theme.spacing(1)
  }, placedObject), children);
};
var _default = exports.default = PlacementWrapper;